import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container } from "reactstrap";

import SearchLogsForm from "../../components/search-logs-form";
import {
  getLogs,
  clearLogs,
  setCurrentPage,
  setLogsItemsPerPage,
} from "../../actions";
import {
  logsSelector,
  logsPageInfoSelector,
  logsIsLoadingSelector,
  logsNoEntriesMessage,
} from "../../selectors";
import LogsTable from "../../components/logs-table";
import { logTypeOptions } from "../../constants/logTypeConstants.js";

import DetailsModal from "../../../../components/modals/details-modal";

import "./logsPage.css";
import Pagination from "../../../../components/Pagination/Pagination.jsx";
import PageTitle from "../../../../components/common/PageTitle.jsx";
import FullscreenLoader from "../../../../layouts/FullScreenLoader.js";
import NoEntriesMessage from "../../../../components/common/NoEntriesMessage/NoEntriesMessage.jsx";

const LogsPage = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(logsIsLoadingSelector);
  const [isOpenDetails, setIsOpenDetails] = useState(false);
  const [logMessage, setLogMessage] = useState("");
  const [isOpenCollapse, setIsOpenCollapse] = useState(true);
  const noEntriesMessage = useSelector(logsNoEntriesMessage);
  const toggleCollapse = () => setIsOpenCollapse(!isOpenCollapse);

  const toggleDetails = (message) => {
    setLogMessage(message);
    setIsOpenDetails(!isOpenDetails);
  };

  const logs = useSelector(logsSelector);
  const { count, itemsPerPage, currentPage } =
    useSelector(logsPageInfoSelector);

  useEffect(
    () => () => {
      dispatch(clearLogs());
    },
    []
  );

  useEffect(() => {
    if (count > 0) {
      dispatch(getLogs({ take: itemsPerPage }));
    }
  }, [count]);

  const onPageChange = (_, page) => {
    dispatch(setCurrentPage(page + 1));
    const skip = page * itemsPerPage;
    dispatch(getLogs({ take: itemsPerPage, skip }));
  };

  const onRowsPerPageChange = ({ target }) => {
    dispatch(setCurrentPage(1));
    dispatch(setLogsItemsPerPage(Number(target.value)));
    dispatch(getLogs({ take: Number(target.value), skip: 0 }));
  };

  return (
    <Container
      className="logs-page-container col-12 p-0"
      tabIndex="0"
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          document.getElementById("searchLogsSubmitButton").click();
        }
      }}
    >
      <PageTitle title="logs" />
      <FullscreenLoader loading={isLoading} />
      <SearchLogsForm
        isOpenCollapse={isOpenCollapse}
        toggleCollapse={toggleCollapse}
        logTypeOptions={logTypeOptions}
        entriesLogs={logs}
      />
      {logs.length ? null : <div className="logs-page-background-logo" />}

      {isOpenCollapse ? (
        <div className="overlay-collapse-open" onClick={toggleCollapse} />
      ) : null}
      {logs.length > 0 && (
        <React.Fragment>
          <LogsTable toggleDetails={toggleDetails} logs={logs} />
          {count && (
            <td className="mt-5 mb-5 d-flex justify-content-center ">
              <Pagination
                count={count}
                onPageChange={onPageChange}
                onRowsPerPageChange={onRowsPerPageChange}
                rowsPerPage={itemsPerPage}
                page={currentPage - 1}
              />
            </td>
          )}
        </React.Fragment>
      )}
      <DetailsModal
        toggle={() => toggleDetails(logMessage)}
        isOpen={isOpenDetails}
        modalHeader="Log Entry Details"
        modalBody={logMessage}
      />
      {noEntriesMessage ? (
        <NoEntriesMessage payload={noEntriesMessage} />
      ) : null}
    </Container>
  );
};

export default LogsPage;



// WEBPACK FOOTER //
// ./src/features/log/pages/logs-page/LogsPage.jsx